import styled from 'styled-components';

const Toast = styled.div`
  color: ${({ theme }) => theme.commons.tooltip.textColor};
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  border-radius: 6px;
  z-index: ${({ theme }) => theme.commons.tooltip.zIndex};
  background-color: ${({ theme }) => theme.commons.tooltip.background};
  position: fixed;
  padding: 10px;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: 16px;
  width: 255px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export default Toast;
